import React from 'react'
import { FaComment, FaEye } from 'react-icons/fa'
import Dead from '../../images/dead.jpg'
export const FAQ = () => {

    return (
        <>
            <div className="container">
                <h3 className="m-b30 text-dark text-center">Frequently Asked Questions</h3>
                <div className="row">
                    <div className="col-md-1 col-sm-3 col-3">
                        <img src={Dead} alt="" width={"100%"} style={{
                            borderRadius: 51,
                            height: 65
                        }} />
                    </div>
                    <div className="col-md-11">
                        {/* name,date etc */}
                        <div className="row">
                            <div className="username">
                                <h5>Martin Hope</h5>
                            </div>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <div className="tag">
                                <div>
                                    <h6 className='bg-danger text-white'><b>Admin</b></h6>
                                </div>
                            </div>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <div className="date">
                                <p>Asked : <span className='text-primary'>10/Jan/2010</span>
                                </p>
                            </div>
                        </div>
                        {/* name,date etc */}
                        {/* Quetion And Answer */}
                        <div className="row">
                            <div className="question">
                                <h4>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corrupti facilis ratione blanditiis fugit, dolorum vitae nobis provident commodi hic labore autem voluptatem tempora harum impedit beatae quo libero? Iusto, ullam.</h4>
                            </div>
                            <div className="answer">
                                <p>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dolorum culpa vitae obcaecati est veritatis sunt modi amet illum sed ea facilis enim aspernatur voluptate, maxime architecto. Cum blanditiis commodi odit deserunt.
                                </p>
                            </div>
                        </div>
                        {/* Quetion And Answer */}
                        {/* Reviews */}
                        <div className="row">
                            <div className="comment">
                                <p>
                                    <FaComment />
                                    &nbsp; &nbsp;
                                    <span>4</span>
                                    &nbsp;
                                    Answers
                                </p>
                            </div>
                            &nbsp; &nbsp; &nbsp;
                            &nbsp; &nbsp; &nbsp;
                            <div className="view">
                                <p>
                                    <FaEye />
                                    &nbsp; &nbsp;
                                    <span>4k</span>
                                    &nbsp;
                                    Views
                                </p>
                            </div>

                        </div>
                        {/* Reviews */}
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-1 col-sm-3 col-3">
                        <img src={Dead} alt="" width={"100%"} style={{
                            borderRadius: 51,
                            height: 65
                        }} />
                    </div>
                    <div className="col-md-11">
                        {/* name,date etc */}
                        <div className="row">
                            <div className="username">
                                <h5>Martin Hope</h5>
                            </div>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <div className="tag">
                                <div>
                                    <h6 className='bg-danger text-white'><b>Admin</b></h6>
                                </div>
                            </div>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <div className="date">
                                <p>Asked : <span className='text-primary'>10/Jan/2010</span>
                                </p>
                            </div>
                        </div>
                        {/* name,date etc */}
                        {/* Quetion And Answer */}
                        <div className="row">
                            <div className="question">
                                <h4>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corrupti facilis ratione blanditiis fugit, dolorum vitae nobis provident commodi hic labore autem voluptatem tempora harum impedit beatae quo libero? Iusto, ullam.</h4>
                            </div>
                            <div className="answer">
                                <p>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dolorum culpa vitae obcaecati est veritatis sunt modi amet illum sed ea facilis enim aspernatur voluptate, maxime architecto. Cum blanditiis commodi odit deserunt.
                                </p>
                            </div>
                        </div>
                        {/* Quetion And Answer */}
                        {/* Reviews */}
                        <div className="row">
                            <div className="comment">
                                <p>
                                    <FaComment />
                                    &nbsp; &nbsp;
                                    <span>4</span>
                                    &nbsp;
                                    Answers
                                </p>
                            </div>
                            &nbsp; &nbsp; &nbsp;
                            &nbsp; &nbsp; &nbsp;
                            <div className="view">
                                <p>
                                    <FaEye />
                                    &nbsp; &nbsp;
                                    <span>4k</span>
                                    &nbsp;
                                    Views
                                </p>
                            </div>

                        </div>
                        {/* Reviews */}
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-1 col-sm-3 col-3">
                        <img src={Dead} alt="" width={"100%"} style={{
                            borderRadius: 51,
                            height: 65
                        }} />
                    </div>
                    <div className="col-md-11">
                        {/* name,date etc */}
                        <div className="row">
                            <div className="username">
                                <h5>Martin Hope</h5>
                            </div>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <div className="tag">
                                <div>
                                    <h6 className='bg-danger text-white'><b>Admin</b></h6>
                                </div>
                            </div>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <div className="date">
                                <p>Asked : <span className='text-primary'>10/Jan/2010</span>
                                </p>
                            </div>
                        </div>
                        {/* name,date etc */}
                        {/* Quetion And Answer */}
                        <div className="row">
                            <div className="question">
                                <h4>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corrupti facilis ratione blanditiis fugit, dolorum vitae nobis provident commodi hic labore autem voluptatem tempora harum impedit beatae quo libero? Iusto, ullam.</h4>
                            </div>
                            <div className="answer">
                                <p>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dolorum culpa vitae obcaecati est veritatis sunt modi amet illum sed ea facilis enim aspernatur voluptate, maxime architecto. Cum blanditiis commodi odit deserunt.
                                </p>
                            </div>
                        </div>
                        {/* Quetion And Answer */}
                        {/* Reviews */}
                        <div className="row">
                            <div className="comment">
                                <p>
                                    <FaComment />
                                    &nbsp; &nbsp;
                                    <span>4</span>
                                    &nbsp;
                                    Answers
                                </p>
                            </div>
                            &nbsp; &nbsp; &nbsp;
                            &nbsp; &nbsp; &nbsp;
                            <div className="view">
                                <p>
                                    <FaEye />
                                    &nbsp; &nbsp;
                                    <span>4k</span>
                                    &nbsp;
                                    Views
                                </p>
                            </div>

                        </div>
                        {/* Reviews */}
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-1 col-sm-3 col-3">
                        <img src={Dead} alt="" width={"100%"} style={{
                            borderRadius: 51,
                            height: 65
                        }} />
                    </div>
                    <div className="col-md-11">
                        {/* name,date etc */}
                        <div className="row">
                            <div className="username">
                                <h5>Martin Hope</h5>
                            </div>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <div className="tag">
                                <div>
                                    <h6 className='bg-danger text-white'><b>Admin</b></h6>
                                </div>
                            </div>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <div className="date">
                                <p>Asked : <span className='text-primary'>10/Jan/2010</span>
                                </p>
                            </div>
                        </div>
                        {/* name,date etc */}
                        {/* Quetion And Answer */}
                        <div className="row">
                            <div className="question">
                                <h4>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corrupti facilis ratione blanditiis fugit, dolorum vitae nobis provident commodi hic labore autem voluptatem tempora harum impedit beatae quo libero? Iusto, ullam.</h4>
                            </div>
                            <div className="answer">
                                <p>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dolorum culpa vitae obcaecati est veritatis sunt modi amet illum sed ea facilis enim aspernatur voluptate, maxime architecto. Cum blanditiis commodi odit deserunt.
                                </p>
                            </div>
                        </div>
                        {/* Quetion And Answer */}
                        {/* Reviews */}
                        <div className="row">
                            <div className="comment">
                                <p>
                                    <FaComment />
                                    &nbsp; &nbsp;
                                    <span>4</span>
                                    &nbsp;
                                    Answers
                                </p>
                            </div>
                            &nbsp; &nbsp; &nbsp;
                            &nbsp; &nbsp; &nbsp;
                            <div className="view">
                                <p>
                                    <FaEye />
                                    &nbsp; &nbsp;
                                    <span>4k</span>
                                    &nbsp;
                                    Views
                                </p>
                            </div>

                        </div>
                        {/* Reviews */}
                    </div>
                </div>
                <hr />
            </div>
        </>

    )
}
